import React, { useEffect } from "react";

const iosUrl = "https://apps.apple.com/in/app/moc-ccrc/id6448766368";
const androidUrl = "https://play.google.com/store/apps/details?id=com.mocmobileapp";

const AppLink: React.FC = () => {
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
        const isAndroid = /android/i.test(userAgent);

        if (isIOS) {
            window.location.href = iosUrl;
        } else if (isAndroid) {
            window.location.href = androidUrl;
        }
    }, []);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center min-vh-100 text-center px-3 bg-light">
            <h1 className="h3 mb-3">Redirecting...</h1>
            <p className="text-muted mb-4">
                If you are not automatically redirected, please click the button below that matches your device.
            </p>

            <div className="d-flex flex-column flex-sm-row gap-3 align-items-center">
                <a href={iosUrl} className="btn d-flex align-items-center justify-content-center">
                    <img
                        src="/appStore.png"
                        alt="Download on App Store"
                        style={{ width: "120px", height: "auto" }}
                    />
                </a>
                <a href={androidUrl} className="btn d-flex align-items-center justify-content-center">
                    <img
                        src="/playStore.png"
                        alt="Get it on Google Play"
                        style={{ width: "120px", height: "auto" }}
                    />
                </a>
            </div>
        </div>
    );
};

export default AppLink;